<template>
  <div>
    <v-navigation-drawer clipped v-model="drawer" width="250" color="#dee9fc" app mobile-breakpoint="100"
      :mini-variant="minivariant" :expand-on-hover="minivariant">
      <v-divider />

      <div class="alertExpiration" v-if="showMessageExpiracao()">
        O contrato irá expirar em {{ formatDateString(configuracao.dtExpiracao) }} .<br />
        Por favor entre em contato com o suporte.<br />
      </div>

      <v-btn style="margin-left: 100px;" v-if="carregandoMenus" large icon disabled :loading="carregandoMenus">
        <v-icon>mdi-cached</v-icon>
      </v-btn>

      <v-list nav dense>
        <!-- Quando não é um grupo -->
        <v-list-item color="#011b42" :to="item.to" v-for="item in items.filter(m => !m.children && showMenu(m))"
          :key="item.title">
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>

        <!-- Quando é um grupo -->
        <v-list-group v-for="item in items.filter(m => m.children && showMenu(m))" :key="item.title" color="black"
          v-show="item.children" :prepend-icon="item.icon" no-action :value="value">
          <template v-slot:activator>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </template>

          <template v-for="record in item.children">
            <v-list-item color="#011b42" :key="record.title" :to="record.to" v-if="showMenu(record)">
              <v-list-item-icon>
                <v-icon>{{ record.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-title>{{ record.title }}</v-list-item-title>
            </v-list-item>
          </template>
        </v-list-group>
      </v-list>

      <div class="copyright" v-if="!minivariant">
        Copyright &copy; 2025 - Cemicloud<br />
        Todos os direitos reservados<br />
        Versão: {{ $store.getters['General/appVersion'] }}
      </div>
      <div class="copyright" v-if="minivariant">
        Versão: {{ $store.getters['General/appVersion'] }}
      </div>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import configuracaoService from "../../service/ConfiguracaoService";

export default {
  data() {
    return {
      user: [],
      value: false,
      listGroup: 0,
      drawer: true,
      carregandoMenus: false,
      items: [],
      configuracao: {
        dtInicial: null,
        dtExpiracao: null,
        isEmImplantacao: false,
        isMostraCodigoSepultamento: false,
        isMostraPerpetua: false,
        isCriarPerpetuaSepultamento: false
      }
    };
  },
  computed: {
    ...mapGetters({
      minivariant: "General/minivariant"
    })
  },
  methods: {
    showMenu(item) {
      const roles = item.children ? item.children.flatMap(c => c.roles) : item.roles;
      return roles.some(role => this.user.roles.includes(role));
    },
    criarMenus() {
      var menus = this.$store.getters['Config/getMenus'];
      this.items = menus.map(menu => (
        {
          title: menu.nome,
          icon: menu.icone,
          to: menu.rota,
          visivel: menu.visivel,
          roles: menu.funcionalidades.map(f => f.identificador),
          children: menu.subMenus.length == 0 ? undefined : menu.subMenus.map(sm => (
            {
              title: sm.nome,
              icon: sm.icone,
              to: sm.rota,
              visivel: sm.visivel,
              roles: sm.funcionalidades.map(f => f.identificador)
            }
          ))
        }));
    },
    async buscarConfiguraca() {
      const response = await configuracaoService.consultar();
      if (response.data) {
        this.configuracao = response.data
        this.configuracao.isEmImplantacao = response.data.flEmImplantacao === 'S'
        this.configuracao.dtExpiracao = response.data.dtExpiracao;
        this.configuracao.isMostraCodigoSepultamento = response.data.flMostraCodigoSepultamento === 'S'
        this.configuracao.isMostraPerpetua = response.data.flMostraPerpetua === 'S'
        this.configuracao.isCriarPerpetuaSepultamento = response.data.flCriarPerpetuaSepultamento === 'S'
      }
      console.log('Show: ', this.showMessageExpiracao());
    },
    formatDateString(dateString) {
      // Criar um objeto Date a partir da string de data
      const date = new Date(dateString);

      // Extrair dia, mês e ano
      const day = String(date.getDate()).padStart(2, '0'); // Adiciona 0 à esquerda se necessário
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Janeiro é 0!
      const year = date.getFullYear();

      // Formatar para o formato desejado
      return `${day}/${month}/${year}`;
    },
    showMessageExpiracao() {
      if (!this.configuracao || !this.configuracao.dtExpiracao)
        return false;

        if(this.isDate30DaysAway())
          return true;

        return false;
    },
    isDate30DaysAway() {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const targetDate = new Date(this.configuracao.dtExpiracao);
      targetDate.setHours(0, 0, 0, 0);
      const timeDifference = targetDate - today;
      const daysDifference = timeDifference / (1000 * 60 * 60 * 24);    
      return daysDifference < 30;
    }
  },
  created() {
    this.carregandoMenus = true
    this.buscarConfiguraca();

    this.$store.dispatch("Login/getUser")
      .then(response => {
        this.user = response;
        this.criarMenus();
        for (let i = 0; i < this.items.length; i++) {
          if (this.$router.currentRoute.fullPath === this.items[i].to) {
            this.listGroup = i;
          }
        }
      })
      .finally(() => {
        this.carregandoMenus = false;
      })
  }
};
</script>

<style>
.v-list-item__icon {
  margin-right: 15px !important;
}

.v-application--is-ltr .v-list-group--no-action>.v-list-group__items>.v-list-item {
  padding-left: 35px !important;
}

.copyright {
  font-size: 11px;
  text-align: center;
  bottom: 20px;
  position: absolute;
  width: 100%;
  color: #5e7ba7
}

.alertExpiration {
  font-size: 18px;
  text-align: center;
  bottom: 90px;
  position: absolute;
  width: 100%;
  color: red;
  font-weight: bold;
}
</style>